const mixin = {
  methods: {
    /**
     * @description format value unit based on number of bytes
     * @param {object} item
     * @returns Unit value
     */
    $_resolveValueUnit(item) {
      const bytes = Number(item?.size);
      if (bytes === 0) return '-';

      const k = 1024;
      const decimals = 0;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
  },
};

export default mixin;
